var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Sidebar'),_c('div',{staticClass:"main-content",attrs:{"id":"panel"}},[_c('Navbar'),_c('div',{staticClass:"container-fluid mt--6"},[_c('router-view'),_c('Footer')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }